'use strict';

/*globals app*/
/*globals services*/
/*globals invokeCallback*/

function ReasonService() {
  this.modal = null;

  this.reason = null;

  this.init();
}

ReasonService.prototype = $.extend({}, {
  constructor: 'ReasonService',

  //----------------------------------------------------------------------------

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.modal.contentDOM().on('click', '.reason__item--select', function () {
      _this.doChooseReason($(this));

      return false;
    });

    _this.modal.contentDOM().on('click', '.reason__item--switch', function () {
      _this.switchReasons($(this));

      return false;
    });

    _this.modal.contentDOM().on('click', '.reasons__back', function () {
      _this.backReasons($(this).data('node_id'));

      return false;
    });
  },

  //----------------------------------------------------------------------------

  switchReasons: function switchReasons($reason) {
    var _this = this;

    var $wrapper = _this.modal.contentDOM();
    $wrapper.find('.reason__item-wrapper').hide();
    if ($reason) {
      $wrapper.find('.reason__item-wrapper[data-node_id="' + $reason.data('id') + '"]').show();
    } else {
      $wrapper.find('.reason__item-wrapper[data-node_id="0"]').show();
    }

    var $breadcrumbs = $wrapper.find('.reasons__breadcrumbs');
    var $footer = $wrapper.find('.reasons__footer');
    var $backBtn = $wrapper.find('.reasons__back');

    if ($reason) {
      $breadcrumbs.text($reason.text());
      $breadcrumbs.show();

      $footer.show();

      $backBtn.data('node_id', $reason.closest('.reason__item-wrapper').data('node_id') || 0);
    } else {
      $breadcrumbs.hide();
      $footer.hide();
    }

    return _this;
  },

  backReasons: function backReasons(treeId) {
    var _this = this;

    var $wrapper = _this.modal.contentDOM();

    var $reason = $wrapper.find('.reason__item[data-id="' + treeId + '"]');
    if (!$reason.length) {
      $reason = null;
    }

    _this.switchReasons($reason);

    return _this;
  },

  getReasonByAbbr: function getReasonByAbbr(abbr, callback) {
    var _this = this;

    app.get(app.path('reason_get_by_abbr', { Abbr: abbr }), function (res) {
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, res.data);
      } else {
        invokeCallback(callback, null);
      }
    });

    return _this;
  },

  findReason: function findReason(id) {
    var reason = null;
    $.each(app.param('reasons'), function (key, item) {
      if (item.id === id) {
        reason = { Id: item.id, Abbr: item.abbr, Description: item.abbr };

        return false;
      }
    });

    return reason;
  },

  doChooseReason: function doChooseReason($reason) {
    var _this = this;

    _this.reason = {
      Id: $reason.data('id'),
      Abbr: $reason.data('abbr'),
      Description: $reason.data('description'),
    };

    //pri uzavreni se vola callback, ktery vrati zvoleny duvod
    _this.modal.close();

    return _this;
  },

  chooseReason: function chooseReason(workplaceRID, callback) {
    var _this = this;

    _this.reason = null;

    _this.modal.open({
      title: app.t('reasons.title'),
      height: 'auto',
      width: 'lg',
      closeCallBack: function () {
        invokeCallback(callback, _this.reason);
      }
    });

    _this.modal.block();
    app.get(app.path('reason_get_by_workplace', { WorkplaceRID: workplaceRID }), function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-output');

    _this.registerCallbacks();

    return _this;
  }
});
